
import 'highcharts/modules/map';
import worldMap from '@highcharts/map-collection/custom/world.geo.json';

const Highcharts = window.Highcharts;

Highcharts.maps = Highcharts.maps || {};
Highcharts.maps['custom/world'] = worldMap;

window.Highcharts = Highcharts;
